/**
 * Created by Bart Decorte
 * Date: 03/11/2018
 * Time: 19:32
 */
import UsersManipulate from './UsersManipulate';

class UsersEdit extends UsersManipulate {
  constructor() {
    super();
    this.bindKeys(this.keyBindings());
  }
}

export default UsersEdit;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/Users/UsersEdit.js